import * as OverweightBaggage from './components/OverweightBaggage.css';
export default {
    OverweightBaggage
};
